import { render, staticRenderFns } from "./playVideo.vue?vue&type=template&id=0f9afd4a&scoped=true"
import script from "./playVideo.vue?vue&type=script&lang=js"
export * from "./playVideo.vue?vue&type=script&lang=js"
import style0 from "./playVideo.vue?vue&type=style&index=0&id=0f9afd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9afd4a",
  null
  
)

export default component.exports